module.exports = __webpack_public_path__ + "221f78319de24b4cf37f84f92487b6f8.svg";